import { Component } from '@angular/core';

@Component({
  selector: 'thank-you',
  template: `<page-title [title]="title"></page-title>
            <div class="text-center">
                <div [innerHTML]="'thankYou.text' | translate"></div>
            </div>`,
})
export class ThankYouComponent {
  title = 'thankYou.title';

}
